import React from "react";
import { motion } from "framer-motion";

export const easeOut = [0.16, 1, 0.3, 1];

export const Reveal = ({ children, delay = 0, y = 40, className = "", once = true }) => (
  <motion.div
    className={className}
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once, margin: "-10% 0px -10% 0px" }}
    transition={{ duration: 0.9, ease: easeOut, delay }}
  >
    {children}
  </motion.div>
);

// Masked line reveal: pass array of lines
export const MaskedLines = ({ lines, className = "", lineClassName = "", start = 0.2, stagger = 0.12 }) => (
  <span className={className}>
    {lines.map((line, i) => (
      <span key={i} className="mask-line">
        <motion.span
          style={{ display: "block" }}
          className={lineClassName}
          initial={{ y: "110%" }}
          animate={{ y: "0%" }}
          transition={{ duration: 1.1, ease: easeOut, delay: start + i * stagger }}
        >
          {line}
        </motion.span>
      </span>
    ))}
  </span>
);
